import React, { useState } from 'react';

const Apresentacao: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'intro' | 'organograma' | 'fluxograma' | 'telas'>('intro');

  return (
    <div className="apresentacao-container">
      <style>
        {`
          .apresentacao-container {
            background-color: #f8f9fa;
            min-height: 100vh;
            padding-bottom: 5rem;
            color: #333;
            font-family: 'Inter', system-ui, -apple-system, sans-serif;
          }
          .presentation-header {
            background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%) !important;
            color: #ffffff !important;
            padding: 4rem 2rem;
            text-align: center;
            border-bottom-left-radius: 40px;
            border-bottom-right-radius: 40px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.1);
            margin-bottom: 3rem;
          }
          .presentation-header h1 {
            color: #ffffff !important;
          }
          .title-highlight {
            color: #38bdf8 !important;
            font-weight: 800;
          }
          .header-subtitle {
            color: #94a3b8 !important;
          }
          .nav-pills-custom .nav-link {
            color: #64748b !important;
            font-weight: 600;
            padding: 1rem 1.5rem;
            border-radius: 30px;
            transition: all 0.3s ease;
            background-color: transparent;
            border: none;
            cursor: pointer;
            margin: 0.2rem;
          }
          .nav-pills-custom .nav-link:hover {
            color: #0ea5e9 !important;
            background-color: #e0f2fe !important;
          }
          .nav-pills-custom .nav-link.active {
            background-color: #0ea5e9 !important;
            color: #ffffff !important;
            box-shadow: 0 4px 10px rgba(14, 165, 233, 0.3);
          }
          .card-custom {
            border: none;
            border-radius: 20px;
            box-shadow: 0 10px 40px 0 rgba(0,0,0,0.08);
            background: #ffffff;
            overflow: hidden;
            transition: transform 0.3s ease;
            color: #334155;
          }
          .card-custom:hover {
            transform: translateY(-5px);
          }
          .text-heading {
            color: #0f172a !important;
          }
          .text-paragraph {
            color: #475569 !important;
          }
          .flow-step {
            display: flex;
            align-items: flex-start;
            margin-bottom: 2.5rem;
            position: relative;
          }
          .flow-step:not(:last-child)::after {
            content: '';
            position: absolute;
            left: 25px;
            top: 60px;
            bottom: -30px;
            width: 2px;
            background-color: #e2e8f0;
          }
          .flow-icon {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background-color: #0ea5e9;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.5rem;
            font-weight: bold;
            flex-shrink: 0;
            margin-right: 1.5rem;
            box-shadow: 0 4px 10px rgba(14, 165, 233, 0.3);
            z-index: 2;
          }
          .img-presentation {
            width: 100%;
            height: auto;
            border-bottom: 1px solid #f1f5f9;
            background-color: #f8f9fa;
          }
          .tab-content-animation {
            animation: fadeIn 0.5s ease-in-out;
          }
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .bg-light-primary { background-color: #e0f2fe; }
          .bg-light-success { background-color: #dcfce7; }
          .bg-light-info { background-color: #ffedd5; }
          .bg-light-danger { background-color: #fee2e2; }
          .bg-light-warning { background-color: #fef9c3; }
          .text-primary-custom { color: #0284c7; }
          .text-success-custom { color: #16a34a; }
          .text-info-custom { color: #ea580c; }
          
          /* Flowchart Specific Styles */
          .diagram-box {
            padding: 1.5rem;
            border-radius: 12px;
            text-align: center;
            font-weight: bold;
            box-shadow: 0 4px 6px rgba(0,0,0,0.05);
            position: relative;
            background: #ffffff;
            border: 2px solid #cbd5e1;
            color: #1e293b;
          }
          .diagram-arrow {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 1rem 0;
            color: #94a3b8;
            font-size: 1.5rem;
          }
          .diagram-box.start { border-color: #3b82f6; background-color: #eff6ff; }
          .diagram-box.decision { border-color: #f59e0b; background-color: #fffbeb; border-radius: 30px; }
          .diagram-box.process { border-color: #10b981; background-color: #ecfdf5; }
          .diagram-box.end { border-color: #ef4444; background-color: #fef2f2; }
          .diagram-box.review { border-color: #8b5cf6; background-color: #f5f3ff; }
        `}
      </style>

      {/* Header */}
      <div className="presentation-header">
        <h1 className="display-4 fw-bolder mb-3" style={{ color: '#ffffff' }}>Bem-vindo ao Sistema <span className="title-highlight">Cultiva</span></h1>
        <p className="fs-3 header-subtitle" style={{ color: '#94a3b8' }}>Solução completa para identificar e assistir crianças, adolescentes e suas famílias em situação de vulnerabilidade</p>
      </div>

      <div className="container">
        {/* Navigation */}
        <div className="d-flex justify-content-center mb-5 flex-wrap">
          <ul className="nav nav-pills nav-pills-custom">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'intro' ? 'active' : ''}`}
                onClick={() => setActiveTab('intro')}
              >
                1. O Projeto
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'organograma' ? 'active' : ''}`}
                onClick={() => setActiveTab('organograma')}
              >
                2. Organograma
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'fluxograma' ? 'active' : ''}`}
                onClick={() => setActiveTab('fluxograma')}
              >
                3. Fluxograma
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'telas' ? 'active' : ''}`}
                onClick={() => setActiveTab('telas')}
              >
                4. Telas e Acessos
              </button>
            </li>
          </ul>
        </div>

        {/* Content */}
        <div className="tab-content-animation">
          {activeTab === 'intro' && (
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="card-custom p-5 text-center">
                  <h2 className="mb-4 text-heading fw-bold">O que é o Cultiva?</h2>
                  <p className="fs-4 text-paragraph mb-5" style={{ lineHeight: '1.8' }}>
                    O sistema Cultiva é um software que auxilia o fluxo de projetos voltados para
                    ajudar crianças, adolescentes e suas famílias em situações de vulnerabilidade, sendo aplicado diretamente nas escolas.
                    Ele conecta professores, diretores, articuladores, consultores especializados (saúde, educação, assistência social)
                    e revisores numa rede de apoio rápida e integrada.
                  </p>

                  <div className="mb-5">
                    <img
                      src={`/media/slides/sistema cultiva.png`}
                      className="img-fluid rounded shadow-sm border"
                      alt="Sistema Cultiva"
                      style={{ maxHeight: '450px', objectFit: 'contain', width: '100%' }}
                      onError={(e) => {
                        e.currentTarget.style.display = 'none';
                        const parent = e.currentTarget.parentElement;
                        if (parent) {
                          const warning = document.createElement('div');
                          warning.className = 'p-5 text-center text-paragraph bg-light';
                          warning.innerText = 'Imagem não encontrada ou nome incorreto';
                          parent.prepend(warning);
                        }
                      }}
                    />
                  </div>

                  <div className="d-flex justify-content-center flex-wrap gap-4 mt-4">
                    <div className="p-4 bg-light-primary rounded flex-fill">
                      <h3 className="text-primary-custom fw-bolder">+ Rapidez</h3>
                      <span className="text-paragraph">No diagnóstico</span>
                    </div>
                    <div className="p-4 bg-light-success rounded flex-fill">
                      <h3 className="text-success-custom fw-bolder">Integração</h3>
                      <span className="text-paragraph">Da rede de apoio</span>
                    </div>
                    <div className="p-4 bg-light-info rounded flex-fill">
                      <h3 className="text-info-custom fw-bolder">Efetividade</h3>
                      <span className="text-paragraph">Na resolução do caso</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'organograma' && (
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="card-custom p-5">
                  <h2 className="mb-5 text-center text-heading fw-bold">Organograma de Atuação</h2>

                  <div className="flow-step">
                    <div className="flow-icon" style={{ backgroundColor: '#3b82f6' }}>1</div>
                    <div>
                      <h3 className="fw-bolder text-heading mb-2">Professor</h3>
                      <p className="fs-5 text-paragraph">
                        O processo sempre inicia na sala de aula. Ao identificar sinais de vulnerabilidade no aluno, o professor acessa o sistema e preenche o formulário chamado <strong>"Caso"</strong>. Nesse momento, ele detalha quem é a criança e o que foi observado.
                      </p>
                    </div>
                  </div>

                  <div className="flow-step">
                    <div className="flow-icon" style={{ backgroundColor: '#f43f5e' }}>2</div>
                    <div>
                      <h3 className="fw-bolder text-heading mb-2">Gestor (Diretor da Escola)</h3>
                      <p className="fs-5 text-paragraph">
                        Após receber a notificação, o gestor atua como o primeiro filtro. Ele avalia se o caso narrado pelo professor tem consistência e deve prosseguir. Ele pode <strong>Aprovar</strong> ou <strong>Reprovar</strong> a sequência do atendimento.
                      </p>
                    </div>
                  </div>

                  <div className="flow-step">
                    <div className="flow-icon" style={{ backgroundColor: '#10b981' }}>3</div>
                    <div>
                      <h3 className="fw-bolder text-heading mb-2">Articulador</h3>
                      <p className="fs-5 text-paragraph">
                        Com a aprovação, o Articulador assume a linha de frente presencial. Ele realiza visitas até a família e aplica o <strong>Formulário de Mapeamento</strong> (Anamnese). As respostas (palavras-chave) vão gerar <strong>automaticamente</strong> diversos encaminhamentos no sistema.
                      </p>
                    </div>
                  </div>

                  <div className="flow-step">
                    <div className="flow-icon" style={{ backgroundColor: '#8b5cf6' }}>4</div>
                    <div>
                      <h3 className="fw-bolder text-heading mb-2">Consultor Especialista</h3>
                      <p className="fs-5 text-paragraph">
                        Os encaminhamentos automáticos vão para especialistas (Saúde, Educação, Assistência Social). Cada consultor enxerga e analisa apenas a área da qual domina. Eles avaliam tecnicamente e decidem se vão <strong>Aprovar</strong> ou <strong>Negar</strong> aquela rota sugerida pelo sistema.
                      </p>
                    </div>
                  </div>

                  <div className="flow-step">
                    <div className="flow-icon" style={{ backgroundColor: '#f59e0b' }}>5</div>
                    <div>
                      <h3 className="fw-bolder text-heading mb-2">Revisor</h3>
                      <p className="fs-5 text-paragraph">
                        É o "filtro de qualidade" gerencial do processo. Somente os encaminhamentos que já passaram pelos Consultores caem na mesa do Revisor. Ele analisa tudo de forma mais ampla, podendo <strong>Aprovar</strong> ou <strong>Pedir Alterações</strong>.
                      </p>
                    </div>
                  </div>



                </div>
              </div>
            </div>
          )}

          {activeTab === 'fluxograma' && (
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="card-custom p-5">
                  <h2 className="mb-5 text-center text-heading fw-bold">Fluxograma de Recursos e Processos</h2>

                  <div className="row g-4 align-items-center mb-5">
                    <div className="col-md-3">
                      <div className="diagram-box start">
                        <h4 className="fw-bold mb-2 text-heading">1. Formulário do Caso</h4>
                        <p className="text-sm mb-0 text-paragraph">Preenchido pelo Professor informando suspeita e dados do aluno.</p>
                      </div>
                    </div>
                    <div className="col-md-1 text-center diagram-arrow">→</div>
                    <div className="col-md-4">
                      <div className="diagram-box decision">
                        <h4 className="fw-bold mb-2 text-heading">2. Análise do Gestor</h4>
                        <p className="text-sm mb-2 text-paragraph">Avalia a consistência do caso.</p>
                        <div className="d-flex justify-content-center gap-2 mt-3">
                          <span className="badge bg-success">Aprova</span>
                          <span className="badge bg-danger">Reprova</span>
                        </div>
                      </div>
                      <div className="text-center mt-2 small text-danger">Reprovados ficam visíveis para auditoria dos administradores (Painel de Casos Arquivados).</div>
                    </div>
                    <div className="col-md-1 text-center diagram-arrow">→</div>
                    <div className="col-md-3">
                      <div className="diagram-box process">
                        <h4 className="fw-bold mb-2 text-heading">3. Formulário do Articulador</h4>
                        <p className="text-sm mb-0 text-paragraph">Visita à família e preenchimento do Mapeamento (Anamnese).</p>
                      </div>
                    </div>
                  </div>

                  <div className="row g-4 align-items-center mb-4">
                    <div className="col-12 text-center text-muted fs-5" style={{ color: '#94a3b8' }}>
                      ↓ Encaminhamentos Automáticos
                    </div>
                  </div>

                  <div className="row g-4 align-items-center mb-5 justify-content-center">
                    <div className="col-md-4">
                      <div className="diagram-box decision border-info bg-light-info">
                        <h4 className="fw-bold mb-2 text-heading">4. Análise dos Consultores</h4>
                        <p className="text-sm mb-2 text-paragraph">Aprovação por especialidade (Saúde, Educação, etc).</p>
                        <div className="d-flex justify-content-center gap-2 mt-3">
                          <span className="badge bg-success">Aprova</span>
                          <span className="badge bg-danger">Nega</span>
                        </div>
                      </div>
                      <div className="text-center mt-2 small text-danger lh-sm">Negados ficam registrados com justificativa técnica. O Revisor e o Gestor podem consultar o histórico.</div>
                    </div>
                    <div className="col-md-1 text-center diagram-arrow">→</div>
                    <div className="col-md-4">
                      <div className="diagram-box review">
                        <h4 className="fw-bold mb-2 text-heading">5. Revisor Geral</h4>
                        <p className="text-sm mb-0 text-paragraph">Aprova os encaminhamentos ou pede ajustes.</p>
                      </div>
                    </div>
                  </div>

                  <div className="mt-5 p-4 bg-light rounded border">
                    <h5 className="fw-bold text-heading">Resumo: O que acontece com os Não Aprovados/Reprovados?</h5>
                    <ul className="text-paragraph mt-3 mb-0" style={{ lineHeight: '1.8' }}>
                      <li><strong>Casos Reprovados pelo Gestor:</strong> Não acionam a rede. O caso é encerrado com status "Não Aceito". Administradores ou diretores superiores podem acessar o "Histórico de Casos Inativos" para futuras análises de padrão.</li>
                      <li><strong>Encaminhamentos Negados por Consultores:</strong> O caso do aluno continua ativo, mas apenas a rota negada (ex: psicólogo) é fechada, com justificativa obrigatória. Revisor e artículador tomam ciência.</li>
                      <li><strong>Alterações pedidas pelo Revisor:</strong> O status volta e exige justificativas ou complemento de informações.</li>
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          )}

          {activeTab === 'telas' && (
            <div className="row g-5">
              <div className="col-12 text-center mb-4">
                <h2 className="text-heading fw-bold">Ambientes de Acesso ao Sistema</h2>
                <p className="text-paragraph fs-4">Visão individualizada conforme o papel de cada integrante na rede.</p>
              </div>

              {[
                { title: 'Acesso do Professor', desc: 'Focado nos relatórios e criação de novos casos em sala de aula.', img: 'acesso professor.png' },
                { title: 'Acesso do Administrador e Gestor', desc: 'Controle de alunos, cadastros base e aprovação inicial dos casos', img: 'acesso administrador e gestor.png' },
                { title: 'Acesso do Articulador', desc: 'Área com foco de controle de visitas, preenchimentos dos mapeamentos', img: 'acesso articulador.png' },
                { title: 'Acesso do Consultor', desc: 'Lista de encaminhamentos pendentes classificados por especialidade da área.', img: 'acesso consultor.png' },
                { title: 'Acesso do Revisor', desc: 'Lista unificada de encaminhamentos pré-aprovados ou negados pelos consultores para o pente fino de qualidade.', img: 'acesso revisor.png' },
              ].map((item, idx) => (
                <div className="col-lg-6" key={idx}>
                  <div className="card-custom h-100 d-flex flex-column">
                    <img
                      src={`/media/slides/${item.img}`}
                      className="img-presentation"
                      alt={item.title}
                      onError={(e) => {
                        e.currentTarget.style.display = 'none';
                        const parent = e.currentTarget.parentElement;
                        if (parent) {
                          const warning = document.createElement('div');
                          warning.className = 'p-5 text-center text-paragraph bg-light';
                          warning.innerText = 'Imagem não encontrada ou nome incorreto';
                          parent.prepend(warning);
                        }
                      }}
                    />
                    <div className="p-4 flex-grow-1">
                      <h3 className="fw-bolder text-heading mb-2">{item.title}</h3>
                      <p className="text-paragraph fs-5 m-0">{item.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Apresentacao;
